import { useMemo } from 'react';

import { type User, useAuth, useRegion } from '@spotify/confidence-core-react';

import { useCurrentUser } from '../useCurrentUser';

interface BuildFlagEvaluationContextOptions {
  user?: User;
  currentUserEmail?: string;
  orgName?: string;
  identity?: string;
}

const buildFlagEvaluationContext = ({
  user,
  currentUserEmail,
  orgName,
  identity,
}: BuildFlagEvaluationContextOptions): User => ({
  ...user,
  email: currentUserEmail ?? user?.email,
  org_name: orgName,
  identity,
});

export const useFlagEvaluationContext = (): User => {
  const { user, orgName, identity, isAuthenticated } = useAuth();
  const region = useRegion();
  const { currentUser } = useCurrentUser({
    skip: !isAuthenticated || !region,
  });
  const currentUserEmail = currentUser?.user?.email;

  return useMemo(
    () =>
      buildFlagEvaluationContext({
        user,
        currentUserEmail,
        orgName,
        identity,
      }),
    [user, currentUserEmail, orgName, identity],
  );
};
